<template>
  <div id="footer-div" class="footer text-center">
    <div class="logo-footer">
      <img :src="logoFooter" alt="logoFooter" />
    </div>
    <!-- <div class="find">Find us at</div>
    <div class="icon-ig"><i class="fab fa-instagram"></i></div>-->
    <div class="contact">
      <router-link to="/contact" tag="div">Contact</router-link>
      <router-link to="/terms" tag="div">Terms & Conditions</router-link>
      <router-link to="/contact">Partners</router-link>
    </div>
    <div class="mongolia-travel">© Mongolia.Travel 2019</div>
  </div>
</template>

<script>
import logoFooter from "../assets/img/logo-footer.png";
export default {
  name: "footer-div",
  data() {
    return {
      logoFooter: logoFooter
    };
  }
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 25px 0 10px 0;
  background-color: #e13036;
  color: #ffffff;
  font-size: 12px;

  a {
    color: #ffffff;
    display: inline-block;
  }

  .find {
    padding-top: 30px;
  }

  .icon-ig {
    padding-top: 10px;
  }

  .contact {
    padding-top: 30px;
    display: flex;
    justify-content: space-between;

    &>* {
      width: 33.33%;
    }
  }

  .mongolia-travel {
    padding-top: 20px;
    font-size: 9px;
  }
}
</style>


